export default function TreatmentHistory({
  activeTreatment,
  closedTreatment,
  treatmentEntries,
  visits,
}) {
  // 🔹 combine all treatments
  const allTreatments = [
    ...(activeTreatment || []),
    ...(closedTreatment || []),
  ];

  // 🔹 build history
  const treatmentHistory = allTreatments.map((t) => {
    // 👉 entries for this treatment
    const entries = treatmentEntries.filter(
      (e) => e.treatment_id === t.id
    );

    // 👉 total amount
    const startAmount = entries
  .filter((e) => !e.visit_id) // TRT
  .reduce((sum, e) => sum + (Number(e.amount) || 0), 0);

const visitAmount = visits
  .filter(
    (v) =>
      v.visit_category === "TREATMENT" &&
      entries.some((e) => e.visit_id === v.id)
  )
  .reduce((sum, v) => sum + (Number(v.treatment_amount) || 0), 0);

const totalAmount = startAmount + visitAmount;

    // 👉 check TRT (start entry)
    const hasStart = entries.some((e) => !e.visit_id);

    // 👉 count visits linked to this treatment
    const visitCount = visits.filter(
      (v) =>
        v.visit_category === "TREATMENT" &&
        entries.some((e) => e.visit_id === v.id)
    ).length;

    // 👉 FINAL DAYS (your logic)
    const days = (hasStart ? 1 : 0) + visitCount;

    // 👉 start date
    const start = t.start_date?.toDate
      ? t.start_date.toDate()
      : new Date(t.start_date);

    // 👉 end date
    const end =
      t.status === "COMPLETED"
        ? t.completed_at?.toDate
          ? t.completed_at.toDate()
          : new Date(t.completed_at)
        : null;

    return {
      id: t.id,
      start,
      end,
      days,
      totalAmount,
      status: t.status,
    };
  });

  if (!treatmentHistory.length) return null;

  return (
    <div className="bg-white rounded-xl shadow overflow-x-auto mt-6">
      <h3 className="text-lg font-semibold p-4 text-[#204080]">
        Treatment History
      </h3>

      <table className="w-full text-sm border-collapse text-center">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-3 py-2 border-b">Start Date</th>
            <th className="px-3 py-2 border-b">End Date</th>
            <th className="px-3 py-2 border-b">Sessions</th>
            <th className="px-3 py-2 border-b">Amount</th>
            <th className="px-3 py-2 border-b">Status</th>
          </tr>
        </thead>

        <tbody>
          {treatmentHistory.map((t) => (
            <tr key={t.id} className="border-t">
              {/* START DATE */}
              <td className="px-3 py-2">
                {t.start?.toLocaleDateString("en-IN")}
              </td>

              {/* END DATE */}
              <td className="px-3 py-2">
                {t.status === "COMPLETED"
                  ? t.end?.toLocaleDateString("en-IN")
                  : "Ongoing"}
              </td>

              {/* SESSIONS */}
              <td className="px-3 py-2 font-semibold">
                {t.days}
              </td>

              {/* AMOUNT */}
              <td className="px-3 py-2 font-semibold text-purple-600">
                ₹ {t.totalAmount}
              </td>

              {/* STATUS */}
              <td
                className={`px-3 py-2 font-semibold ${
                  t.status === "ACTIVE"
                    ? "text-green-600"
                    : "text-blue-600"
                }`}
              >
                {t.status}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}